import React, { FC, ReactElement, ReactNode } from "react";

import "./tooltip.scss";

interface TooltipProps {
  children: ReactElement;
  message: ReactNode | string;
  pos?: string;
  center?: boolean;
  fullWidth?: boolean;
}

const Tooltip: FC<TooltipProps> = ({
  children,
  message,
  pos = "top",
  center = false,
  fullWidth = false,
}) => {
  return (
    <div className={`ui-tooltip ${fullWidth ? "ui-tooltip-full-width" : ""}`}>
      {message && (
        <div
          className="ui-tooltip__message"
          style={{
            left: center ? "50%" : "0",
            bottom: pos === "top" ? "110%" : "-350%",
            transform: center ? "translateX(-50%)" : undefined,
          }}
        >
          {message}
        </div>
      )}
      {children}
    </div>
  );
};

export default Tooltip;
